/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ThumbsUpIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABKUlEQVR4nOWUvUpDQRCFr/jzCkIsfAVLESS9YeZMhM2cRLtIOt8jTyDYW1krWtipL6Agau9vJ1pGI7EIMbDXcPcKggem/b7dmWGy7F9FjOdifqfGbghhrnSBGvsj1f1dAfhQKlyE86MCAXulwdfWW4tqPPneIn8sBS7wtpq/jPW/L/CDJLAqK2J+OA4eCoybheGAryr4HIWDV51OZ7YgvLUk4GsMrjkl4I3UG8tReAhhWsHLInAdrq+fRgVa95AEty/BUVwA7qfABf4O+EqOwG/TBOzVamEhKhD4U2qLBNyOC4zXyTOoNzZyfsC9tAFzp1qtzkQFQFNSBqzKSvZDphQ8KyoBmlsTnWUxvygmcM8myeDODF4j5scCv1fjRz7c39S4W/g+/el8AhRY2w7Q51TzAAAAAElFTkSuQmCC)
 */
export const ThumbsUpIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M15 5a3 3 0 0 0-3-3 1 1 0 0 0-1 1v2a3 3 0 0 1-.19 1.05L6.55 8.93a7.9 7.9 0 0 0-3.26 8.4c.43 1.77 1.44 3.42 3.14 4.07.86.34 1.89.6 2.95.6h8.03a2.09 2.09 0 0 0 1.93-2.88l-.4-.97a.2.2 0 0 1 .08-.24l.54-.33a1.99 1.99 0 0 0 .8-2.44l-.43-1.02a.25.25 0 0 1 .03-.23l.6-.9a1.92 1.92 0 0 0-1.6-2.99h-5.39A8 8 0 0 0 15 5.44V5Z"
        className={colorClass}
      />
    </svg>
  );
};
